<template>
  <div>
    <ObjectDetail></ObjectDetail>
  </div>
</template>
  
  <script>
import ObjectDetail from "@/components/public-umkm-bermitra-detail/ObjectDetail.vue";

export default {
  name: "ObjectDetailView",
  components: {
    ObjectDetail,
    // ObjectDetail
  },
};
</script>
  
  <style scoped>
</style>
  